import { useQuery } from '@tanstack/react-query'
import { getMemberOpportunityIncentiveAccepts, getMemberOpportunityIncentives } from '@/lib'
import { queryKeys } from '@/lib/queryKeys'
import { useAuthStore } from '@/stores/auth'

interface UseOpportunityIncentivesParams {
  period?: string
  enabled?: boolean
}

interface UseOpportunityIncentiveAcceptsParams {
  enabled?: boolean
}

/**
 * メンバーのインセンティブ一覧を取得するフック
 */
export function useOpportunityIncentives({ period, enabled = true }: UseOpportunityIncentivesParams = {}) {
  const user = useAuthStore((state) => state.user)
  const memberId = user?.memberId

  return useQuery({
    queryKey: queryKeys.opportunity.incentives(memberId, period),
    queryFn: async () => {
      if (!memberId) {
        throw new Error('Member ID not found')
      }
      return getMemberOpportunityIncentives(memberId, { period })
    },
    enabled: enabled && !!memberId,
  })
}

/**
 * メンバーのインセンティブ確認履歴を取得するフック
 */
export function useOpportunityIncentiveAccepts({ enabled = true }: UseOpportunityIncentiveAcceptsParams = {}) {
  const user = useAuthStore((state) => state.user)
  const memberId = user?.memberId

  return useQuery({
    queryKey: queryKeys.opportunity.incentiveAccepts(memberId),
    queryFn: async () => {
      if (!memberId) {
        throw new Error('Member ID not found')
      }
      return getMemberOpportunityIncentiveAccepts(memberId)
    },
    enabled: enabled && !!memberId,
  })
}
